import { atom } from 'recoil';

export const exclusionsAtom = atom({
  key: 'exclusionsAtom',
  default: {
    loading: false,
    items: []
  },
});